/**
 * Canonical site origin, used for canonical URLs, Open Graph images and
 * JSON-LD structured data.
 *
 * This was previously hard-coded as https://www.bytegurukul.com in nine
 * files while the backend's FRONTEND_URL pointed at bytegurukul.tech, so
 * canonicals and social images referenced a different domain to the one
 * being served. Set REACT_APP_SITE_URL per environment to change it.
 */
const raw = process.env.REACT_APP_SITE_URL || "https://www.bytegurukul.tech";

// Trailing slashes produce "//courses" when concatenated with a path.
export const SITE_URL = raw.replace(/\/+$/, "");

/** Absolute URL for a site-relative path. */
export const absoluteUrl = (path = "/") =>
  `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export default SITE_URL;
